<template>
  <v-container class="mt-5 ml-2">
    <v-snackbar v-model="snackbar" top :timeout="3000" color="error">
      Selecciona los ciclos por favor
      <v-btn text color="white" @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>

    <v-snackbar v-model="snackbarOk" top :timeout="2500" color="success">
      {{ mensajeOk }}
    </v-snackbar>

    <v-row>
      <v-col cols="12">
        <v-card outlined class="pa-3 mb-3">
          <div class="subtitle-2 grey--text text--darken-1 mb-1">Resumen RI (vista filtrada · misma regla KPI General)</div>
          <v-row dense align="center">
            <v-col cols="6" sm="3"><strong>Reinscribibles</strong><br />{{ kpiResumen.act }}</v-col>
            <v-col cols="6" sm="3"><strong>Acumulado</strong><br />{{ kpiResumen.sig }}</v-col>
            <v-col cols="6" sm="3"><strong>Faltantes</strong><br />{{ kpiResumen.fal }}</v-col>
            <v-col cols="6" sm="3"><strong>% RI</strong><br />{{ kpiResumen.pct }}%</v-col>
          </v-row>
        </v-card>

        <v-data-table
          :headers="headers"
          :items="rigrupos"
          class="elevation-1"
          :items-per-page="10"
          :footer-props="{ itemsPerPageOptions: [10], showFirstLastPage: true }"
          dense
          mobile-breakpoint="200"
          :height="560"
          fixed-header
          :search="search"
          sort-by="faltantes"
          sort-desc
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>RI GRUPOS</v-toolbar-title>
              <v-divider class="mx-4" inset vertical />
              <v-spacer />
              <v-btn class="mr-2" small dark color="green" @click="exportar()">
                <v-icon>mdi-microsoft-excel</v-icon>
              </v-btn>
              <v-btn class="mr-2" small dark color="indigo" @click="abrirReporte()">
                Reporte
              </v-btn>
              <v-btn color="primary" small @click="consultar()">Consultar</v-btn>
            </v-toolbar>
            <v-card-text class="pb-0">
              <v-row>
                <v-col cols="12" sm="6" lg="4" xl="3">
                  <v-autocomplete
                    outlined
                    dense
                    clearable
                    v-model="cicloInf"
                    :items="ciclos"
                    label="Selecciona ciclo actual"
                    hide-details
                    return-object
                    item-text="ciclo"
                    item-value="id_ciclo"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="4" xl="3">
                  <v-autocomplete
                    outlined
                    dense
                    clearable
                    v-model="cicloSup"
                    :items="ciclos"
                    label="Selecciona siguiente ciclo"
                    hide-details
                    return-object
                    item-text="ciclo"
                    item-value="id_ciclo"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="4" xl="3">
                  <v-autocomplete
                    outlined
                    dense
                    clearable
                    v-model="filterPlantel"
                    :items="plantelesOpciones"
                    label="Plantel"
                    hide-details
                    item-text="text"
                    item-value="value"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="4" xl="3">
                  <v-autocomplete
                    outlined
                    dense
                    clearable
                    v-model="filterEstado"
                    :items="zonasOpciones"
                    label="Zona / región (planteles.estado)"
                    hide-details
                    item-text="text"
                    item-value="value"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text>
              <v-text-field label="Buscar" outlined dense v-model="search" hide-details />
            </v-card-text>
          </template>

          <template v-slot:item.alumnos_ciclo_actual="{ item }">
            <v-chip small color="primary" dark label @click.stop="abrirChip(item, 'actual')">
              {{ item.alumnos_ciclo_actual }}
            </v-chip>
          </template>
          <template v-slot:item.alumnos_siguiente_ciclo="{ item }">
            <v-chip small color="teal" dark label @click.stop="abrirChip(item, 'siguiente')">
              {{ item.alumnos_siguiente_ciclo }}
            </v-chip>
          </template>
          <template v-slot:item.faltantes="{ item }">
            <v-chip small color="orange" dark label @click.stop="abrirChip(item, 'faltantes')">
              {{ item.faltantes }}
            </v-chip>
          </template>
          <template v-slot:item.promesa_pago="{ item }">
            <v-chip small color="indigo" dark label @click.stop="abrirChip(item, 'promesa_pago')">
              {{ item.promesa_pago || 0 }}
            </v-chip>
          </template>

          <template v-slot:item.porcentaje_ri="{ item }">
            {{ item.porcentaje_ri != null ? item.porcentaje_ri : '-' }}
          </template>

          <template v-slot:item.validacion="{ item }">
            <div class="d-flex align-center flex-wrap" style="gap: 6px; max-width: 220px;">
              <v-switch
                dense
                hide-details
                class="mt-0 pt-0"
                :input-value="!!Number(item.validado)"
                @change="onToggleValidado(item, $event)"
              />
              <v-text-field
                v-if="!Number(item.validado)"
                dense
                hide-details
                placeholder="Motivo"
                v-model="item.motivo"
                @blur="patchGrupo(item, { validado: false, motivo: item.motivo, comentarios: item.comentarios })"
              />
            </div>
          </template>

          <template v-slot:item.comentarios="{ item }">
            <v-textarea
              v-model="item.comentarios"
              dense
              rows="2"
              hide-details
              placeholder="Comentarios"
              @blur="patchGrupo(item, { comentarios: item.comentarios })"
            />
          </template>

          <template v-slot:no-data>
            <v-btn color="primary" small @click="initialize">Actualizar</v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogAlumnos" max-width="1360" scrollable>
      <v-card>
        <v-card-title class="headline">
          {{ tituloChip }}
          <v-spacer />
          <v-btn small color="green" dark class="mr-2" @click="descargarCsvDetalle">
            <v-icon left small>mdi-download</v-icon> CSV
          </v-btn>
          <v-btn icon @click="dialogAlumnos = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text style="max-height: 420px">
          <v-data-table
            :key="detalleTablaKey"
            :headers="headersAlumnos"
            :items="alumnosDetalle"
            :loading="loadingAlumnos"
            dense
            hide-default-footer
            :items-per-page="-1"
          >
            <template v-slot:item.tiene_telefono="{ item }">
              <div class="d-flex align-center justify-center flex-nowrap" style="gap: 6px; min-width: 210px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      small
                      class="ri-wa-btn"
                      :class="{ 'ri-wa-btn--blocked': !puedeAbrirTwilio(item) }"
                      @click="abrirTwilioAlumno(item)"
                    >
                      <v-icon small :color="colorIconoWhatsapp(item)">mdi-whatsapp</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ tooltipWhatsapp(item) }}</span>
                </v-tooltip>
                <!-- Ticket 74066: número en espera de verificación -->
                <template v-if="item.telefono_pendiente">
                  <v-chip
                    v-if="puedeVerificarTelefono"
                    small
                    color="primary"
                    dark
                    class="ri-chip-pendiente"
                    @click="abrirVerificarNumero(item)"
                  >
                    Pendiente
                  </v-chip>
                  <v-chip v-else small color="blue lighten-4" class="primary--text">
                    Esperando verificación
                  </v-chip>
                </template>
                <v-btn-toggle
                  v-else
                  dense
                  class="ri-tel-validacion"
                  :value="valorToggleValidacion(item)"
                  @change="onChangeValidacionTelefono(item, $event)"
                >
                  <v-btn
                    small
                    value="1"
                    :color="Number(item.telefono_validacion) === 1 ? 'success' : undefined"
                    :outlined="Number(item.telefono_validacion) !== 1"
                    :disabled="!digitosTelefonoAlumno(item) || !!item._guardandoTel"
                  >
                    Correcto
                  </v-btn>
                  <v-btn
                    small
                    value="0"
                    :color="item.telefono_validacion === 0 || item.telefono_validacion === '0' ? 'error' : undefined"
                    :outlined="!(item.telefono_validacion === 0 || item.telefono_validacion === '0')"
                    :disabled="!digitosTelefonoAlumno(item) || !!item._guardandoTel"
                  >
                    Incorrecto
                  </v-btn>
                </v-btn-toggle>

                <v-btn
                  v-if="item.baja_solicitada"
                  x-small
                  color="grey darken-1"
                  dark
                  @click="abrirInfoBaja(item)"
                >
                  Baja solicitada
                </v-btn>
                <v-btn
                  v-else-if="puedeEditarBajaPromesa"
                  x-small
                  color="error"
                  outlined
                  :loading="!!item._guardandoBaja"
                  @click="abrirSolicitarBaja(item)"
                >
                  Solicitar baja
                </v-btn>
              </div>
            </template>

            <template v-slot:item.comentarios="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                    color="primary"
                    @click="abrirComentariosAlumno(item)"
                  >
                    <v-icon small>mdi-file-document</v-icon>
                  </v-btn>
                </template>
                <span>Ver o agregar comentarios</span>
              </v-tooltip>
            </template>

            <template v-slot:item.promesa_pago="{ item }">
              <div class="d-flex align-center justify-center flex-nowrap" style="min-width: 150px">
                <v-chip
                  v-if="item.promesa_pago"
                  small
                  color="success"
                  outlined
                  label
                >
                  <v-icon left x-small>mdi-lock</v-icon>
                  {{ formatoFechaPromesa(item.promesa_pago) }}
                </v-chip>
                <v-menu
                  v-else-if="puedeEditarBajaPromesa"
                  :value="!!item._menuPromesa"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  @input="$set(item, '_menuPromesa', $event)"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      value=""
                      placeholder="Elegir fecha"
                      prepend-inner-icon="mdi-calendar"
                      readonly
                      dense
                      filled
                      hide-details
                      style="max-width: 138px"
                      :loading="!!item._guardandoPromesa"
                      :disabled="!!item._guardandoPromesa"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    :value="promesaFechaPendiente"
                    locale="es-MX"
                    @input="onSelectPromesaPago(item, $event)"
                  />
                </v-menu>
                <span v-else class="grey--text text-caption">—</span>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmarPromesa" persistent max-width="420">
      <v-card>
        <v-card-title class="subtitle-1">Confirmar promesa de pago</v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          ¿Está seguro de la fecha
          <strong>{{ formatoFechaPromesa(promesaFechaPendiente) }}</strong>
          para
          <strong>{{ alumnoPromesa ? alumnoPromesa.nombre_completo : '' }}</strong>?
          <div class="caption grey--text mt-2">
            Al confirmar, la fecha quedará bloqueada y no podrá editarse.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text :disabled="guardandoPromesaConfirm" @click="cancelarConfirmarPromesa">
            Cancelar
          </v-btn>
          <v-btn color="primary" :loading="guardandoPromesaConfirm" @click="confirmarPromesaPago">
            Sí, confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogComentariosAlumno" persistent max-width="800" scrollable>
      <v-card>
        <v-card-title class="subtitle-1">
          Comentarios — {{ alumnoComentarios ? alumnoComentarios.nombre_completo : '' }}
          <v-spacer />
          <v-btn icon @click="cerrarComentariosAlumno"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text style="max-height: 360px">
          <div v-if="cargandoComentarios" class="text-center py-6">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <div v-else-if="!mensajesComentarios.length" class="grey--text text-center py-6">
            Sin comentarios registrados
          </div>
          <template v-else>
            <div v-for="(msg, i) in mensajesComentarios" :key="i">
              <v-row v-if="msg.id_usuarioerp != getdatosUsuarioERPERP.iderp">
                <v-col cols="12">
                  <v-card class="ml-2 pa-3 mt-2" max-width="420" color="#f2f2f2" style="border-radius: 15px; border-top-left-radius: 0">
                    <div class="text-caption primary--text">{{ msg.usuario }}</div>
                    <div class="text-caption primary--text">{{ msg.perfil }}</div>
                    <div class="text-subtitle-2 mt-1">{{ msg.comentario }}</div>
                    <div class="text-caption grey--text">{{ msg.grupo }}</div>
                    <div class="text-caption grey--text">{{ msg.fecha_creacion }}</div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="12" class="text-right">
                  <v-card class="mr-2 mt-2 pa-3 d-inline-block text-left" max-width="420" dark color="primary" style="border-radius: 15px; border-top-right-radius: 0">
                    <div class="text-subtitle-2">{{ msg.comentario }}</div>
                    <div class="text-caption">{{ msg.grupo }}</div>
                    <div class="text-caption">{{ msg.fecha_creacion }}</div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-text-field
            v-model="mensajeComentario"
            outlined
            dense
            hide-details
            label="Escribir comentario..."
            append-icon="mdi-send"
            @click:append="guardarComentarioAlumno"
            @keyup.enter="guardarComentarioAlumno"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogReporte" max-width="1100" scrollable>
      <v-card>
        <v-card-title class="subtitle-1">
          <template v-if="reporteDetalleVisible">
            <v-btn icon small class="mr-1" @click="cerrarDetalleReporte">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            {{ tituloChip }}
            <v-spacer />
            <v-btn small color="green" dark class="mr-2" :disabled="!alumnosDetalle.length" @click="descargarCsvDetalle">
              <v-icon left small>mdi-download</v-icon> CSV
            </v-btn>
          </template>
          <template v-else>
            Reporte RI por sucursal
            <v-spacer />
            <v-btn
              small
              color="green"
              dark
              class="mr-2"
              :disabled="!reporteSucursales.length || loadingReporte"
              :loading="exportandoReporte"
              @click="descargarReporteSucursales"
            >
              <v-icon left small>mdi-microsoft-excel</v-icon>
              Descargar
            </v-btn>
          </template>
          <v-btn icon @click="dialogReporte = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <template v-if="reporteDetalleVisible">
            <v-data-table
              :key="'rep-det-' + detalleTablaKey"
              :headers="headersReporteDetalle"
              :items="alumnosDetalle"
              :loading="loadingAlumnos"
              dense
              :items-per-page="20"
              :footer-props="{ itemsPerPageOptions: [10, 20, 50], showFirstLastPage: true }"
              class="elevation-0"
            >
              <template v-slot:item.promesa_pago="{ item }">
                {{ item.promesa_pago ? formatoFechaPromesa(item.promesa_pago) : '—' }}
              </template>
              <template v-slot:item.baja_solicitada="{ item }">
                <span v-if="item.baja_solicitada" class="error--text">Sí</span>
                <span v-else>—</span>
              </template>
            </v-data-table>
          </template>
          <template v-else>
            <v-row dense class="mb-3">
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="reporteEscuela"
                  :items="reporteEscuelaOpciones"
                  label="Escuela"
                  filled
                  dense
                  hide-details
                  item-text="text"
                  item-value="value"
                  @change="cargarReporteSucursales"
                />
              </v-col>
              <v-col v-if="reporteMeta" cols="12" sm="6" md="8" class="d-flex align-center">
                <div class="text-caption grey--text">
                  BD: {{ reporteMeta.db }} ({{ reporteMeta.ambiente }})
                  · Promesas: {{ reporteMeta.promesas_bd }}
                  · Bajas: {{ reporteMeta.bajas_bd }}
                </div>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headersReporte"
              :items="reporteSucursales"
              :loading="loadingReporte"
              dense
              :items-per-page="15"
              :footer-props="{ itemsPerPageOptions: [10, 15, 30], showFirstLastPage: true }"
              class="elevation-0"
            >
              <template v-slot:item.alumnos="{ item }">
                <v-chip small color="primary" dark label @click.stop="abrirChipReporte(item, 'alumnos')">
                  {{ item.alumnos }}
                </v-chip>
              </template>
              <template v-slot:item.alumnos_ri="{ item }">
                <v-chip small color="teal" dark label @click.stop="abrirChipReporte(item, 'alumnos_ri')">
                  {{ item.alumnos_ri }}
                </v-chip>
              </template>
              <template v-slot:item.faltantes="{ item }">
                <v-chip small color="orange" dark label @click.stop="abrirChipReporte(item, 'faltantes')">
                  {{ item.faltantes }}
                </v-chip>
              </template>
              <template v-slot:item.promesa_pago="{ item }">
                <v-chip small color="indigo" dark label @click.stop="abrirChipReporte(item, 'promesa_pago')">
                  {{ item.promesa_pago }}
                </v-chip>
              </template>
              <template v-slot:item.baja="{ item }">
                <v-chip small color="error" dark label @click.stop="abrirChipReporte(item, 'baja')">
                  {{ item.baja }}
                </v-chip>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogBaja" persistent max-width="480">
      <v-card>
        <v-card-title class="subtitle-1">
          Solicitar baja
          <v-spacer />
          <v-btn icon :disabled="guardandoBaja" @click="cerrarSolicitarBaja"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <div class="text-caption grey--text mb-2">
            {{ alumnoBaja ? alumnoBaja.nombre_completo : '' }}
          </div>
          <v-textarea
            v-model="motivoBaja"
            label="Motivo (obligatorio)"
            filled
            dense
            rows="3"
            hide-details="auto"
            :rules="[v => !!(v && String(v).trim()) || 'El motivo es obligatorio']"
          />
          <v-checkbox
            v-model="confirmaBaja"
            class="mt-3"
            hide-details
            dense
            label="Estoy de acuerdo en solicitar la baja"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-3">
          <v-spacer />
          <v-btn text small :disabled="guardandoBaja" @click="cerrarSolicitarBaja">Cancelar</v-btn>
          <v-btn
            color="error"
            small
            :loading="guardandoBaja"
            :disabled="!puedeConfirmarBaja"
            @click="confirmarSolicitarBaja"
          >
            Solicitar baja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogBajaInfo" max-width="480">
      <v-card>
        <v-card-title class="subtitle-1">
          Baja solicitada
          <v-spacer />
          <v-btn icon @click="cerrarInfoBaja"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <div class="text-caption grey--text mb-1">Solicitó la baja</div>
          <div class="mb-3">{{ alumnoBajaInfo ? (alumnoBajaInfo.baja_solicitante || '—') : '' }}</div>
          <div class="text-caption grey--text mb-1">Alumno</div>
          <div class="mb-3">{{ alumnoBajaInfo ? alumnoBajaInfo.nombre_completo : '' }}</div>
          <div class="text-caption grey--text mb-1">Motivo</div>
          <div class="body-2" style="white-space: pre-wrap">{{ alumnoBajaInfo ? alumnoBajaInfo.baja_motivo : '' }}</div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-3">
          <v-spacer />
          <v-btn text small color="primary" @click="cerrarInfoBaja">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditarNumero" persistent max-width="440">
      <v-card>
        <v-card-title class="subtitle-1">
          {{ tituloDialogoNumero }}
          <v-spacer />
          <v-btn icon @click="cerrarEditarNumero"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-4">
          <div class="text-caption grey--text mb-2">
            {{ alumnoEditarNumero ? alumnoEditarNumero.nombre_completo : '' }}
          </div>
          <div
            v-if="modoDialogoNumero === 'verificar' && alumnoEditarNumero && alumnoEditarNumero.telefono_anterior"
            class="text-caption mb-2"
          >
            Número actual:
            <strong>{{ alumnoEditarNumero.telefono_anterior }}</strong>
          </div>
          <v-text-field
            v-model="nuevoNumeroWa"
            label="Número (10 dígitos)"
            filled
            dense
            maxlength="10"
            :readonly="campoNumeroSoloLectura"
            :rules="[v => (v && v.replace(/\D/g, '').length === 10) || '10 dígitos']"
            hint="Solo los 10 dígitos del celular"
            persistent-hint
          />
          <div class="text-caption mt-2">
            Se guardará como:
            <strong>{{ previewTwilioAsignado }}</strong>
          </div>
          <div v-if="modoDialogoNumero === 'proponer'" class="text-caption primary--text mt-2">
            Al guardar quedará en espera de verificación.
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-3">
          <v-spacer />
          <v-btn text small @click="cerrarEditarNumero" :disabled="guardandoNumeroWa">Cancelar</v-btn>

          <!-- Proponer cambio (cualquiera tras Incorrecto) -->
          <v-btn
            v-if="modoDialogoNumero === 'proponer'"
            color="primary"
            small
            :loading="guardandoNumeroWa"
            :disabled="!numeroEditarValido"
            @click="proponerNumeroWhatsapp"
          >
            Guardar
          </v-btn>

          <!-- Verificar: aceptar / declinar -->
          <template v-else-if="modoDialogoNumero === 'verificar'">
            <v-btn
              color="error"
              small
              outlined
              :loading="guardandoNumeroWa"
              @click="declinarNumeroWhatsapp"
            >
              Declinar cambio
            </v-btn>
            <v-btn
              color="primary"
              small
              :loading="guardandoNumeroWa"
              :disabled="!numeroEditarValido"
              @click="aceptarNumeroWhatsapp"
            >
              Aceptar cambio
            </v-btn>
          </template>

          <!-- Tras declinar: verificar puede editar y aceptar el nuevo -->
          <v-btn
            v-else-if="modoDialogoNumero === 'editarTrasDeclinar'"
            color="primary"
            small
            :loading="guardandoNumeroWa"
            :disabled="!numeroEditarValido"
            @click="aceptarNumeroWhatsapp"
          >
            Aceptar cambio
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
      <v-card width="200" color="primary" dark>
        <v-card-text align="center" class="text-h6">
          Espera por favor
          <v-progress-linear indeterminate color="white" class="mb-0 mt-2" />
        </v-card-text>
      </v-card>
    </v-overlay>

    <v-dialog v-model="dialogError" hide-overlay persistent max-width="600">
      <v-card color="error" dark style="position: relative">
        <v-card-text class="pt-2">
          Error al recuperar los datos
          <br />
          NOTA: {{ error }}
        </v-card-text>
        <v-btn color="primary" x-small absolute top right fab class="mt-5 mr-0" @click="dialogError = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import XLSX from 'xlsx'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    search: '',
    snackbar: false,
    snackbarOk: false,
    mensajeOk: '',
    headers: [
      { text: 'Grupo', value: 'grupo', width: '280px' },
      { text: 'Reinscribibles', value: 'alumnos_ciclo_actual', align: 'center' },
      { text: 'Acumulado', value: 'alumnos_siguiente_ciclo', align: 'center' },
      { text: '% RI', value: 'porcentaje_ri', align: 'center' },
      { text: 'Teacher 1', value: 'teacher1' },
      { text: 'Teacher 2', value: 'teacher2' },
      { text: 'Faltantes', value: 'faltantes', align: 'center' },
      { text: 'Con fecha o promesa', value: 'promesa_pago', align: 'center' },
      { text: 'Validación', value: 'validacion', sortable: false, width: '220px' },
      { text: 'Comentarios', value: 'comentarios', sortable: false, width: '200px' },
    ],
    headersAlumnos: [
      { text: 'Nombre', value: 'nombre_completo' },
      { text: 'Matrícula', value: 'matricula' },
      { text: 'Teléfono', value: 'telefono' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'WhatsApp / Baja', value: 'tiene_telefono', align: 'center', width: '340px', sortable: false },
      { text: 'Comentarios', value: 'comentarios', align: 'center', sortable: false, width: '90px' },
      { text: 'Promesa de pago', value: 'promesa_pago', align: 'center', sortable: false, width: '160px' },
    ],
    headersReporte: [
      { text: 'Sucursal', value: 'sucursal' },
      { text: 'Reinscribibles', value: 'alumnos', align: 'center' },
      { text: 'Acumulado', value: 'alumnos_ri', align: 'center' },
      { text: 'Faltantes', value: 'faltantes', align: 'center' },
      { text: 'Promesa de pago', value: 'promesa_pago', align: 'center' },
      { text: 'Baja', value: 'baja', align: 'center' },
      { text: '% RI', value: 'porcentaje_ri', align: 'center' },
    ],
    headersReporteDetalle: [
      { text: 'Nombre', value: 'nombre_completo' },
      { text: 'Matrícula', value: 'matricula' },
      { text: 'Teléfono', value: 'telefono' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Promesa de pago', value: 'promesa_pago', align: 'center' },
      { text: 'Baja', value: 'baja_solicitada', align: 'center' },
    ],
    reporteEscuelaOpciones: [
      { text: 'Ambos', value: 'ambos' },
      { text: 'INBI', value: 'inbi' },
      { text: 'FAST', value: 'fast' },
    ],
    ciclos: [],
    cicloInf: null,
    cicloSup: null,
    plantelesRaw: [],
    plantelesOpciones: [],
    zonasOpciones: [
      { text: 'Corporativo / especial (0)', value: 0 },
      { text: 'Monterrey / zona 1', value: 1 },
      { text: 'CDMX / zona 2', value: 2 },
      { text: 'Zona 3', value: 3 },
      { text: 'FAST / zona 4', value: 4 },
    ],
    filterPlantel: null,
    filterEstado: null,
    rigrupos: [],
    overlay: false,
    dialogError: false,
    error: '',
    dialogAlumnos: false,
    tituloChip: '',
    alumnosDetalle: [],
    loadingAlumnos: false,
    chipContext: null,
    dialogComentariosAlumno: false,
    alumnoComentarios: null,
    mensajesComentarios: [],
    mensajeComentario: '',
    cargandoComentarios: false,
    detalleRequestId: 0,
    detalleCancel: null,
    detalleTablaKey: 0,
    dialogEditarNumero: false,
    alumnoEditarNumero: null,
    nuevoNumeroWa: '',
    guardandoNumeroWa: false,
    /** proponer | verificar | editarTrasDeclinar */
    modoDialogoNumero: 'proponer',
    /** Ticket 74066: Paola 1312, Esther 568, José Miguel 3042 */
    idsVerificadoresTelefono: [1312, 568, 3042],
    dialogReporte: false,
    reporteEscuela: 'ambos',
    reporteSucursales: [],
    reporteMeta: null,
    reporteDetalleVisible: false,
    loadingReporte: false,
    exportandoReporte: false,
    dialogBaja: false,
    alumnoBaja: null,
    motivoBaja: '',
    confirmaBaja: false,
    guardandoBaja: false,
    dialogBajaInfo: false,
    alumnoBajaInfo: null,
    dialogConfirmarPromesa: false,
    alumnoPromesa: null,
    promesaFechaPendiente: null,
    guardandoPromesaConfirm: false,
  }),

  watch: {
    dialogAlumnos(val) {
      if (!val) this.cancelarDetalleAlumnos()
    },
    dialogReporte(val) {
      if (!val) {
        this.cancelarDetalleAlumnos()
        this.reporteDetalleVisible = false
        this.chipContext = null
      }
    },
    cicloInf() {
      if (!this.cicloInf) {
        this.cicloSup = null
        return
      }
      const siguiente = this.resolverCicloSiguiente(this.cicloInf)
      if (siguiente) {
        this.cicloSup = siguiente
        this.overlay = true
        this.rigrupos = []
        this.consultar()
      } else {
        this.cicloSup = null
        this.rigrupos = []
        this.snackbar = true
      }
    },
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    kpiResumen() {
      let act = 0
      let sig = 0
      for (const r of this.rigrupos) {
        act += Number(r.alumnos_ciclo_actual) || 0
        sig += Number(r.alumnos_siguiente_ciclo) || 0
      }
      const fal = Math.max(act - sig, 0)
      const pct = act > 0 ? ((sig / act) * 100).toFixed(2) : '0.00'
      return { act, sig, fal, pct }
    },

    digitosNuevoNumero() {
      return String(this.nuevoNumeroWa || '').replace(/\D/g, '').slice(-10)
    },

    numeroEditarValido() {
      return this.digitosNuevoNumero.length === 10 && !this.guardandoNumeroWa
    },

    previewTwilioAsignado() {
      const d = this.digitosNuevoNumero
      return d.length === 10 ? `whatsapp:+521${d}` : 'whatsapp:+521XXXXXXXXXX'
    },

    puedeVerificarTelefono() {
      const id = Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp)
      return this.idsVerificadoresTelefono.includes(id)
    },

    /** Solo en Faltantes se puede marcar baja / promesa (no Reinscribibles ni Acumulado). */
    puedeEditarBajaPromesa() {
      return !!(this.chipContext && this.chipContext.tipo === 'faltantes')
    },

    tituloDialogoNumero() {
      if (this.modoDialogoNumero === 'verificar') return 'Verificar cambio de número'
      if (this.modoDialogoNumero === 'editarTrasDeclinar') return 'Modificar número de WhatsApp'
      return 'Corregir número de WhatsApp'
    },

    campoNumeroSoloLectura() {
      return this.modoDialogoNumero === 'verificar'
    },

    puedeConfirmarBaja() {
      return !!(
        this.confirmaBaja &&
        String(this.motivoBaja || '').trim() &&
        !this.guardandoBaja
      )
    },
  },

  created() {
    this.initialize()
  },

  methods: {
    errMsg(err) {
      return (
        (err.response && err.response.data && (err.response.data.message || err.response.data.Message)) ||
        err.message ||
        String(err)
      )
    },

    tieneNumeroTelefono(item) {
      if (!item) return false
      if (item.tiene_telefono === true || item.tiene_telefono === 1) return true
      return !!this.digitosTelefonoAlumno(item)
    },

    /**
     * Color del logo: verde solo si el back reporta match CRM Alumnos
     * (twilio.chats.crmalumnos: id_alumno + usuario). Independiente de Correcto/Incorrecto.
     */
    tieneWhatsappCrm(item) {
      if (!item) return false
      return item.tiene_whatsapp === true || item.tiene_whatsapp === 1
    },

    digitosTelefonoAlumno(item) {
      if (!item) return ''
      const campos = [item.telefono, item.celular, item.twilio_asignado, item.twilio_texto]
      for (const valor of campos) {
        const digits = String(valor || '').replace(/\D/g, '')
        if (digits.length >= 10) return digits
      }
      return ''
    },

    valorToggleValidacion(item) {
      if (!item || item.telefono_validacion === null || item.telefono_validacion === undefined || item.telefono_validacion === '') {
        return null
      }
      return String(Number(item.telefono_validacion) === 1 ? 1 : 0)
    },

    /** Se puede ir al CRM si hay un número de al menos 10 dígitos (se liga al abrir). */
    puedeAbrirTwilio(item) {
      return !!this.digitosTelefonoAlumno(item)
    },

    colorIconoWhatsapp(item) {
      return this.tieneWhatsappCrm(item) ? 'green' : 'red'
    },

    tooltipWhatsapp(item) {
      if (!this.digitosTelefonoAlumno(item)) {
        return 'Sin número válido para abrir el CRM'
      }
      if (this.tieneWhatsappCrm(item)) {
        return 'Ligado en CRM Alumnos: ' + (item.usuario || item.twilio_asignado) + ' — clic para abrir'
      }
      return 'Sin match en CRM Alumnos (sin chat con usuario). Clic para ligar el número y abrir el CRM'
    },

    esAlumnoFast(item) {
      if (!item) return false
      if (Number(item.unidad_negocio) === 2) return true
      const grupo = String(item.grupo || '').toUpperCase()
      return grupo.includes('FAST')
    },

    /** Ícono WhatsApp: liga el número si falta y abre el CRM en otra pestaña (deja el modal abierto). */
    async abrirTwilioAlumno(item) {
      const digits = this.digitosTelefonoAlumno(item)
      if (!digits || digits.length < 10) {
        this.error = 'El alumno no tiene un número válido para abrir el CRM'
        this.dialogError = true
        return
      }

      // Si aún no está ligado en CRM, ligarlo antes de navegar.
      if (!this.tieneWhatsappCrm(item)) {
        const ok = await this.ligarNumeroAlumno(item, digits.slice(-10))
        if (!ok) return
      }

      const last10 = this.digitosTelefonoAlumno(item).slice(-10)
      // localStorage: sessionStorage no se comparte entre pestañas nuevas.
      try {
        localStorage.setItem('crmAlumnoTmp', last10)
        localStorage.setItem('crmAlumnoTmpAutoOpen', '1')
      } catch (e) { /* ignore */ }
      sessionStorage.setItem('crmAlumnoTmp', last10)
      sessionStorage.setItem('crmAlumnoTmpAutoOpen', '1')
      // FAST → CRM Alumnos Fast; INBI u otros → CRM Alumnos
      const routeName = this.esAlumnoFast(item) ? 'crmAlumnosFast' : 'crmAlumnos'
      const resolved = this.$router.resolve({
        name: routeName,
        query: { crmTel: last10, crmAuto: '1' },
      })
      const opened = window.open(resolved.href, '_blank')
      if (!opened) {
        this.error = 'El navegador bloqueó la ventana emergente. Permite pop-ups para abrir el chat.'
        this.dialogError = true
      }
    },

    /**
     * Liga/actualiza el twilio_asignado del alumno (canónico whatsapp:+521..).
     * Devuelve true si quedó ligado. Refleja el estado en el item.
     */
    async ligarNumeroAlumno(item, telefono10) {
      if (!item || !item.id_alumno) return false
      this.$set(item, '_guardandoTel', true)
      try {
        const { data } = await this.$http.patch(
          'kpi.ri.alumno.twilio.asignado/' + item.id_alumno,
          { telefono: telefono10 }
        )
        const ligado = !!(data && data.tiene_whatsapp && data.usuario)
        this.$set(item, 'twilio_asignado', (data && data.twilio_asignado) || '')
        this.$set(item, 'usuario', ligado ? data.usuario : '')
        this.$set(item, 'tiene_whatsapp', ligado)
        if (data.telefono10) this.$set(item, 'telefono', data.telefono10)
        this.mensajeOk = data.mensaje || 'Número ligado correctamente'
        this.snackbarOk = true
        if (data.conflicto_otro_alumno && data.conflicto_otro_alumno.length) {
          const nombres = data.conflicto_otro_alumno.map((a) => a.nombre).join(', ')
          this.error = 'Atención: este número ya estaba ligado a: ' + nombres
          this.dialogError = true
        }
        return true
      } catch (e) {
        this.error = this.errMsg(e)
        this.dialogError = true
        return false
      } finally {
        this.$set(item, '_guardandoTel', false)
      }
    },

    onChangeValidacionTelefono(item, value) {
      if (!item || !item.id_alumno) return
      const actual = this.valorToggleValidacion(item)
      // Segundo clic en el mismo valor = limpiar validación
      let siguiente = value
      if (siguiente != null && String(siguiente) === String(actual)) {
        siguiente = null
      }
      if (siguiente === null || siguiente === undefined || siguiente === '') {
        this.guardarValidacionTelefono(item, null)
        return
      }
      const estado = Number(siguiente) === 1 ? 1 : 0
      this.guardarValidacionTelefono(item, estado)
      // Incorrecto → permitir corregir el número que se usa para el WhatsApp verde.
      if (estado === 0) {
        this.abrirEditarNumero(item)
      }
    },

    abrirEditarNumero(item) {
      this.alumnoEditarNumero = item
      this.nuevoNumeroWa = this.digitosTelefonoAlumno(item).slice(-10)
      this.modoDialogoNumero = 'proponer'
      this.dialogEditarNumero = true
    },

    abrirVerificarNumero(item) {
      if (!this.puedeVerificarTelefono || !item) return
      this.alumnoEditarNumero = item
      this.nuevoNumeroWa = String(item.telefono_propuesto || '').replace(/\D/g, '').slice(-10)
      this.modoDialogoNumero = 'verificar'
      this.dialogEditarNumero = true
    },

    cerrarEditarNumero() {
      this.dialogEditarNumero = false
      this.alumnoEditarNumero = null
      this.nuevoNumeroWa = ''
      this.modoDialogoNumero = 'proponer'
    },

    aplicarEstadoPendienteLocal(item, data) {
      this.$set(item, 'telefono_pendiente', !!(data && data.telefono_pendiente))
      this.$set(item, 'telefono_propuesto', (data && data.telefono_propuesto) || '')
      this.$set(item, 'telefono_anterior', (data && data.telefono_anterior) || item.telefono_anterior || '')
      if (item.telefono_pendiente) {
        this.$set(item, 'telefono_validacion', 0)
      }
    },

    /** Guarda propuesta (no aplica el número hasta que un verificador acepte). */
    async proponerNumeroWhatsapp() {
      if (!this.numeroEditarValido || !this.alumnoEditarNumero) return
      const item = this.alumnoEditarNumero
      this.guardandoNumeroWa = true
      try {
        const { data } = await this.$http.patch(
          'kpi.ri.alumno.twilio.proponer/' + item.id_alumno,
          { telefono: this.digitosNuevoNumero }
        )
        this.aplicarEstadoPendienteLocal(item, {
          telefono_pendiente: true,
          telefono_propuesto: (data && data.telefono_propuesto) || this.digitosNuevoNumero,
          telefono_anterior: (data && data.telefono_anterior) || this.digitosTelefonoAlumno(item).slice(-10),
        })
        this.mensajeOk = (data && data.mensaje) || 'Número en espera de verificación'
        this.snackbarOk = true
        this.cerrarEditarNumero()
        await this.refrescarDetalleAlumnos()
      } catch (e) {
        this.error = this.errMsg(e)
        this.dialogError = true
      } finally {
        this.guardandoNumeroWa = false
      }
    },

    async aceptarNumeroWhatsapp() {
      if (!this.puedeVerificarTelefono || !this.numeroEditarValido || !this.alumnoEditarNumero) return
      const item = this.alumnoEditarNumero
      this.guardandoNumeroWa = true
      try {
        const { data } = await this.$http.patch(
          'kpi.ri.alumno.twilio.aceptar/' + item.id_alumno,
          { telefono: this.digitosNuevoNumero }
        )
        const ligado = !!(data && data.tiene_whatsapp && data.usuario)
        this.$set(item, 'twilio_asignado', (data && data.twilio_asignado) || '')
        this.$set(item, 'usuario', ligado ? data.usuario : '')
        this.$set(item, 'tiene_whatsapp', ligado)
        if (data.telefono10) {
          this.$set(item, 'telefono', data.telefono10)
          this.$set(item, 'celular', data.telefono10)
          this.$set(item, 'twilio_texto', data.telefono10)
        }
        this.$set(item, 'telefono_pendiente', false)
        this.$set(item, 'telefono_propuesto', '')
        this.$set(item, 'telefono_validacion', 1)
        this.mensajeOk = (data && data.mensaje) || 'Cambio aceptado'
        this.snackbarOk = true
        if (data.conflicto_otro_alumno && data.conflicto_otro_alumno.length) {
          const nombres = data.conflicto_otro_alumno.map((a) => a.nombre).join(', ')
          this.error = 'Atención: este número ya estaba ligado a: ' + nombres
          this.dialogError = true
        }
        this.cerrarEditarNumero()
        await this.refrescarDetalleAlumnos()
      } catch (e) {
        this.error = this.errMsg(e)
        this.dialogError = true
      } finally {
        this.guardandoNumeroWa = false
      }
    },

    async declinarNumeroWhatsapp() {
      if (!this.puedeVerificarTelefono || !this.alumnoEditarNumero) return
      const item = this.alumnoEditarNumero
      this.guardandoNumeroWa = true
      try {
        const { data } = await this.$http.patch(
          'kpi.ri.alumno.twilio.declinar/' + item.id_alumno,
          {}
        )
        this.$set(item, 'telefono_pendiente', false)
        this.$set(item, 'telefono_propuesto', '')
        // Mantener incorrecto; permitir modificar
        this.$set(item, 'telefono_validacion', 0)
        this.mensajeOk = (data && data.mensaje) || 'Cambio declinado'
        this.snackbarOk = true
        // Liberar campo para que el verificador edite y acepte un número nuevo
        this.nuevoNumeroWa = this.digitosTelefonoAlumno(item).slice(-10)
        this.modoDialogoNumero = 'editarTrasDeclinar'
      } catch (e) {
        this.error = this.errMsg(e)
        this.dialogError = true
      } finally {
        this.guardandoNumeroWa = false
      }
    },

    guardarValidacionTelefono(item, estado) {
      if (!item || !item.id_alumno) return
      const prev = item.telefono_validacion
      this.$set(item, 'telefono_validacion', estado)
      this.$set(item, '_guardandoTel', true)
      this.$http
        .patch('kpi.ri.alumno.telefono.validacion/' + item.id_alumno, {
          estado,
          telefono: item.telefono || this.digitosTelefonoAlumno(item).slice(-10) || null,
        })
        .then((res) => {
          const est =
            res.data && Object.prototype.hasOwnProperty.call(res.data, 'estado')
              ? res.data.estado
              : estado
          this.$set(item, 'telefono_validacion', est)
          this.mensajeOk =
            est === 1 ? 'Número marcado como correcto' : est === 0 ? 'Número marcado como incorrecto' : 'Validación de número limpiada'
          this.snackbarOk = true
        })
        .catch((e) => {
          this.$set(item, 'telefono_validacion', prev)
          this.error = this.errMsg(e)
          this.dialogError = true
        })
        .finally(() => {
          this.$set(item, '_guardandoTel', false)
        })
    },

    cancelarDetalleAlumnos() {
      this.detalleRequestId += 1
      if (this.detalleCancel) {
        this.detalleCancel('cancelado')
        this.detalleCancel = null
      }
      this.loadingAlumnos = false
    },

    esCancelacionDetalle(err) {
      return axios.isCancel(err) || (err && err.message === 'cancelado')
    },

    initialize() {
      this.ciclos = []
      this.plantelesRaw = []
      this.plantelesOpciones = []
      this.$http
        .get('kpi.planteles.all')
        .then((response) => {
          this.plantelesRaw = response.data || []
          this.armarPlantelesOpciones()
          return this.$http.get('kpi.ciclos.all')
        })
        .then((response) => {
          for (const i in response.data) {
            if (!(response.data[i].ciclo.search('FE') !== -1)) {
              if (response.data[i].ciclo.search('CICLO') !== -1) {
                this.ciclos.push(response.data[i])
              }
            }
          }
        })
        .catch((e) => console.log(e))
    },

    armarPlantelesOpciones() {
      const u = this.getdatosUsuarioERPERP
      const recep =
        u &&
        u.idpuesto === 19 &&
        ![568, 7, 161].includes(u.iderp) &&
        Array.isArray(u.planteles)
      let rows = (this.plantelesRaw || []).map((p) => ({
        text: p.plantel,
        value: p.id_plantel,
        estado: p.estado,
      }))
      if (recep) {
        const permitidos = new Set(u.planteles.map((x) => x.idplantel))
        rows = rows.filter((r) => permitidos.has(r.value))
      }
      this.plantelesOpciones = rows.sort((a, b) => a.text.localeCompare(b.text))
    },

    resolverCicloSiguiente(cicloActual) {
      if (!cicloActual || !this.ciclos.length) return null
      const m = String(cicloActual.ciclo || '').match(/CICLO\s+(\d{2})_(\d{2})/i)
      if (!m) return null
      const nextNum = String(parseInt(m[1], 10) + 1).padStart(2, '0')
      const target = `CICLO ${nextNum}_${m[2]}`
      return this.ciclos.find((c) => c.ciclo === target) || null
    },

    urlRiGrupos() {
      let url =
        'kpi.ri.grupos/' +
        this.cicloInf.id_ciclo +
        '/' +
        this.cicloInf.id_ciclo_relacionado +
        '/' +
        this.cicloSup.id_ciclo +
        '/' +
        this.cicloSup.id_ciclo_relacionado
      const q = []
      if (this.filterPlantel != null && this.filterPlantel !== '') {
        q.push('id_plantel=' + encodeURIComponent(this.filterPlantel))
      }
      if (this.filterEstado != null && this.filterEstado !== '') {
        q.push('id_estado=' + encodeURIComponent(this.filterEstado))
      }
      if (q.length) url += '?' + q.join('&')
      return url
    },

    async consultar() {
      if (!this.cicloInf || !this.cicloSup) {
        this.snackbar = true
        return
      }
      this.overlay = true
      this.rigrupos = []
      await this.getGrupos()
    },

    getGrupos() {
      return this.$http
        .get(this.urlRiGrupos())
        .then((response) => {
          const data = response.data || []
          const u = this.getdatosUsuarioERPERP
          if (u && u.idpuesto === 19 && ![568, 7, 161].includes(u.iderp)) {
            const rows = []
            for (const i in data) {
              const plantel = u.planteles && u.planteles.find((el) => el.idplantel === data[i].id_plantel)
              if (plantel) rows.push(data[i])
            }
            this.rigrupos = rows
          } else {
            this.rigrupos = data
          }
          this.overlay = false
        })
        .catch((error) => {
          this.error = this.errMsg(error)
          this.dialogError = true
          this.overlay = false
        })
    },

    abrirChip(item, tipo) {
      if (!this.cicloInf || !this.cicloSup) {
        this.snackbar = true
        return
      }
      const map = {
        actual: 'Reinscribibles',
        siguiente: 'Acumulado',
        faltantes: 'Faltantes',
        promesa_pago: 'Con fecha o promesa de pago',
      }
      this.tituloChip = `${item.grupo || ''} — ${map[tipo] || tipo}`
      this.chipContext = { item, tipo }
      this.dialogAlumnos = true
      this.cargarDetalleAlumnos()
    },

    /** Recarga la tabla del modal (faltantes/actual/siguiente) con datos frescos. */
    refrescarDetalleAlumnos() {
      if (!this.chipContext || !this.dialogAlumnos) return Promise.resolve()
      return this.cargarDetalleAlumnos()
    },

    cargarDetalleAlumnos() {
      if (!this.chipContext || !this.cicloInf || !this.cicloSup) return Promise.resolve()
      const { item, tipo } = this.chipContext
      this.cancelarDetalleAlumnos()
      const requestId = this.detalleRequestId
      this.alumnosDetalle = []
      this.loadingAlumnos = true
      const cancelSource = axios.CancelToken.source()
      this.detalleCancel = cancelSource.cancel
      const base =
        'kpi.ri.grupo.alumnos/' +
        item.id_grupo +
        '/' +
        this.cicloInf.id_ciclo +
        '/' +
        this.cicloInf.id_ciclo_relacionado +
        '/' +
        this.cicloSup.id_ciclo +
        '/' +
        this.cicloSup.id_ciclo_relacionado
      return this.$http
        .get(base + '?tipo=' + encodeURIComponent(tipo), { cancelToken: cancelSource.token })
        .then((res) => {
          if (requestId !== this.detalleRequestId) return
          const rows = (res.data && res.data.alumnos) || []
          this.alumnosDetalle = rows
          this.detalleTablaKey += 1
        })
        .catch((e) => {
          if (this.esCancelacionDetalle(e)) return
          if (requestId !== this.detalleRequestId) return
          this.error = this.errMsg(e)
          this.dialogError = true
        })
        .finally(() => {
          if (requestId !== this.detalleRequestId) return
          this.loadingAlumnos = false
          this.detalleCancel = null
        })
    },

    formatoFechaPromesa(fecha) {
      if (!fecha) return ''
      const s = String(fecha).slice(0, 10)
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s)
      if (!m) return s
      return `${m[3]}/${m[2]}/${m[1]}`
    },

    /** Ciclo actual del alumno: INBI → cicloInf.id_ciclo; FAST → relacionado. */
    idCicloRiAlumno(item) {
      if (!this.cicloInf) return null
      return Number(item && item.unidad_negocio) === 2
        ? this.cicloInf.id_ciclo_relacionado
        : this.cicloInf.id_ciclo
    },

    onSelectPromesaPago(item, fecha) {
      if (!this.puedeEditarBajaPromesa) return
      if (!item || !item.id_alumno || item.promesa_pago) return
      this.$set(item, '_menuPromesa', false)
      const nueva = fecha ? String(fecha).slice(0, 10) : null
      if (!nueva) return
      this.alumnoPromesa = item
      this.promesaFechaPendiente = nueva
      this.dialogConfirmarPromesa = true
    },

    cancelarConfirmarPromesa() {
      if (this.guardandoPromesaConfirm) return
      this.dialogConfirmarPromesa = false
      this.alumnoPromesa = null
      this.promesaFechaPendiente = null
    },

    confirmarPromesaPago() {
      const item = this.alumnoPromesa
      const nueva = this.promesaFechaPendiente
      if (!this.puedeEditarBajaPromesa || !item || !item.id_alumno || !nueva || item.promesa_pago) {
        this.cancelarConfirmarPromesa()
        return
      }
      const idCiclo = this.idCicloRiAlumno(item)
      if (!idCiclo) {
        this.error = 'No se pudo determinar el ciclo para la promesa de pago'
        this.dialogError = true
        return
      }

      this.guardandoPromesaConfirm = true
      this.$set(item, '_guardandoPromesa', true)
      this.$http
        .patch('kpi.ri.alumno.promesa.pago/' + item.id_alumno, {
          fecha_promesa: nueva,
          id_ciclo: idCiclo,
        })
        .then((res) => {
          const f =
            res.data && Object.prototype.hasOwnProperty.call(res.data, 'fecha_promesa')
              ? res.data.fecha_promesa
              : nueva
          this.$set(item, 'promesa_pago', f || null)
          const grupo = this.chipContext && this.chipContext.item
          if (grupo) {
            this.$set(grupo, 'promesa_pago', (Number(grupo.promesa_pago) || 0) + 1)
          }
          this.mensajeOk = (res.data && res.data.mensaje) || 'Promesa de pago confirmada'
          this.snackbarOk = true
          this.dialogConfirmarPromesa = false
          this.alumnoPromesa = null
          this.promesaFechaPendiente = null
          if (this.dialogReporte) this.cargarReporteSucursales()
        })
        .catch((e) => {
          this.error = this.errMsg(e)
          this.dialogError = true
        })
        .finally(() => {
          this.guardandoPromesaConfirm = false
          this.$set(item, '_guardandoPromesa', false)
        })
    },

    abrirComentariosAlumno(item) {
      if (!item || !item.id_alumno) {
        this.error = 'No se encontró el alumno'
        this.dialogError = true
        return
      }
      this.alumnoComentarios = item
      this.mensajesComentarios = []
      this.mensajeComentario = ''
      this.dialogComentariosAlumno = true
      this.cargarComentariosAlumno(item)
    },

    cerrarComentariosAlumno() {
      this.dialogComentariosAlumno = false
      this.alumnoComentarios = null
      this.mensajesComentarios = []
      this.mensajeComentario = ''
    },

    cargarComentariosAlumno(item) {
      const escuela = item.unidad_negocio || 1
      this.cargandoComentarios = true
      this.$http
        .get(`operaciones.comentario/${item.id_alumno}/${escuela}`)
        .then((res) => {
          this.mensajesComentarios = res.data || []
        })
        .catch((e) => {
          this.error = this.errMsg(e)
          this.dialogError = true
        })
        .finally(() => {
          this.cargandoComentarios = false
        })
    },

    guardarComentarioAlumno() {
      const texto = (this.mensajeComentario || '').trim()
      if (!texto) {
        this.error = 'Ingresa un comentario'
        this.dialogError = true
        return
      }
      if (!this.alumnoComentarios || !this.chipContext) {
        this.error = 'No hay contexto de grupo'
        this.dialogError = true
        return
      }
      const u = this.getdatosUsuarioERPERP
      const grupo = this.chipContext.item
      const payload = {
        id_alumno: this.alumnoComentarios.id_alumno,
        id_usuarioerp: u.iderp,
        id_grupo: grupo.id_grupo,
        id_ciclo: this.cicloInf.id_ciclo,
        comentario: texto,
        idperfil: u.idpuesto,
        unidad_negocio: this.alumnoComentarios.unidad_negocio || 1,
        grupo: grupo.grupo || this.alumnoComentarios.grupo,
        perfil: u.puesto,
      }
      this.cargandoComentarios = true
      this.$http
        .post('operaciones.comentario', payload)
        .then(() => {
          this.mensajeComentario = ''
          this.mensajeOk = 'Comentario guardado'
          this.snackbarOk = true
          this.cargarComentariosAlumno(this.alumnoComentarios)
        })
        .catch((e) => {
          this.error = this.errMsg(e)
          this.dialogError = true
          this.cargandoComentarios = false
        })
    },

    abrirReporte() {
      if (!this.cicloInf || !this.cicloSup) {
        this.snackbar = true
        return
      }
      this.reporteDetalleVisible = false
      this.dialogReporte = true
      this.cargarReporteSucursales()
    },

    cargarReporteSucursales() {
      if (!this.cicloInf || !this.cicloSup) return Promise.resolve()
      this.loadingReporte = true
      this.reporteSucursales = []
      this.reporteMeta = null
      this.reporteDetalleVisible = false
      const url =
        'kpi.ri.reporte.sucursales/' +
        this.cicloInf.id_ciclo +
        '/' +
        this.cicloInf.id_ciclo_relacionado +
        '/' +
        this.cicloSup.id_ciclo +
        '/' +
        this.cicloSup.id_ciclo_relacionado +
        '?escuela=' +
        encodeURIComponent(this.reporteEscuela || 'ambos')
      return this.$http
        .get(url)
        .then((res) => {
          this.reporteSucursales = (res.data && res.data.sucursales) || []
          this.reporteMeta = (res.data && res.data.meta) || null
        })
        .catch((e) => {
          this.error = this.errMsg(e)
          this.dialogError = true
        })
        .finally(() => {
          this.loadingReporte = false
        })
    },

    abrirChipReporte(item, tipo) {
      if (!this.cicloInf || !this.cicloSup || !item || !item.id_plantel) return
      const map = {
        alumnos: 'Reinscribibles',
        alumnos_ri: 'Acumulado',
        faltantes: 'Faltantes',
        promesa_pago: 'Promesa de pago',
        baja: 'Baja',
      }
      this.tituloChip = `${item.sucursal || ''} — ${map[tipo] || tipo}`
      this.chipContext = { item, tipo, origen: 'reporte' }
      this.reporteDetalleVisible = true
      this.cargarDetalleReporte()
    },

    cerrarDetalleReporte() {
      this.cancelarDetalleAlumnos()
      this.reporteDetalleVisible = false
      this.alumnosDetalle = []
      this.chipContext = null
    },

    cargarDetalleReporte() {
      if (!this.chipContext || !this.cicloInf || !this.cicloSup) return Promise.resolve()
      const { item, tipo } = this.chipContext
      this.cancelarDetalleAlumnos()
      const requestId = this.detalleRequestId
      this.alumnosDetalle = []
      this.loadingAlumnos = true
      const cancelSource = axios.CancelToken.source()
      this.detalleCancel = cancelSource.cancel
      const base =
        'kpi.ri.reporte.sucursal.alumnos/' +
        item.id_plantel +
        '/' +
        this.cicloInf.id_ciclo +
        '/' +
        this.cicloInf.id_ciclo_relacionado +
        '/' +
        this.cicloSup.id_ciclo +
        '/' +
        this.cicloSup.id_ciclo_relacionado
      return this.$http
        .get(base + '?tipo=' + encodeURIComponent(tipo), { cancelToken: cancelSource.token })
        .then((res) => {
          if (requestId !== this.detalleRequestId) return
          this.alumnosDetalle = (res.data && res.data.alumnos) || []
          this.detalleTablaKey += 1
        })
        .catch((e) => {
          if (this.esCancelacionDetalle(e)) return
          if (requestId !== this.detalleRequestId) return
          this.error = this.errMsg(e)
          this.dialogError = true
          this.reporteDetalleVisible = false
        })
        .finally(() => {
          if (requestId !== this.detalleRequestId) return
          this.loadingAlumnos = false
          this.detalleCancel = null
        })
    },

    etiquetaEscuelaReporte() {
      const opt = (this.reporteEscuelaOpciones || []).find(
        (o) => o.value === (this.reporteEscuela || 'ambos')
      )
      return (opt && opt.text) || 'Ambos'
    },

    /** Excel real (.xlsx) con título, filtro (Ambos/INBI/FAST), tabla y totales. */
    descargarReporteSucursales() {
      const rows = this.reporteSucursales || []
      if (!rows.length) {
        this.error = 'No hay datos para descargar'
        this.dialogError = true
        return
      }

      this.exportandoReporte = true
      try {
        const escuela = this.etiquetaEscuelaReporte()
        const cicloAct = (this.cicloInf && this.cicloInf.ciclo) || ''
        const cicloSig = (this.cicloSup && this.cicloSup.ciclo) || ''
        const hoy = new Date()
        const fecha =
          String(hoy.getDate()).padStart(2, '0') +
          '/' +
          String(hoy.getMonth() + 1).padStart(2, '0') +
          '/' +
          hoy.getFullYear()

        let totAlumnos = 0
        let totRi = 0
        let totFal = 0
        let totProm = 0
        let totBaja = 0
        for (const r of rows) {
          totAlumnos += Number(r.alumnos) || 0
          totRi += Number(r.alumnos_ri) || 0
          totFal += Number(r.faltantes) || 0
          totProm += Number(r.promesa_pago) || 0
          totBaja += Number(r.baja) || 0
        }
        const pctTotal =
          totAlumnos > 0 ? ((totRi / totAlumnos) * 100).toFixed(2) + '%' : '0.00%'

        const aoa = [
          ['Reporte RI por sucursal'],
          [
            'Escuela: ' +
              escuela +
              '  |  Ciclo actual: ' +
              cicloAct +
              '  |  Ciclo siguiente: ' +
              cicloSig +
              '  |  Fecha: ' +
              fecha +
              '  |  Sucursales: ' +
              rows.length,
          ],
          [],
          [
            'Sucursal',
            'Reinscribibles',
            'Acumulado',
            'Faltantes',
            'Promesa de pago',
            'Baja',
            '% RI',
          ],
        ]

        for (const r of rows) {
          aoa.push([
            r.sucursal || '',
            Number(r.alumnos) || 0,
            Number(r.alumnos_ri) || 0,
            Number(r.faltantes) || 0,
            Number(r.promesa_pago) || 0,
            Number(r.baja) || 0,
            (r.porcentaje_ri != null ? String(r.porcentaje_ri) : '0.00') + '%',
          ])
        }

        aoa.push([
          'TOTAL',
          totAlumnos,
          totRi,
          totFal,
          totProm,
          totBaja,
          pctTotal,
        ])

        const ws = XLSX.utils.aoa_to_sheet(aoa)
        ws['!merges'] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } },
          { s: { r: 1, c: 0 }, e: { r: 1, c: 6 } },
        ]
        ws['!cols'] = [
          { wch: 28 },
          { wch: 12 },
          { wch: 12 },
          { wch: 12 },
          { wch: 16 },
          { wch: 10 },
          { wch: 10 },
        ]

        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Reporte RI')
        const slug = String(this.reporteEscuela || 'ambos').toLowerCase()
        const nombre =
          'RI_reporte_sucursales_' + slug + '_' + hoy.toISOString().slice(0, 10) + '.xlsx'
        XLSX.writeFile(wb, nombre)

        this.mensajeOk = 'Reporte descargado (' + escuela + ')'
        this.snackbarOk = true
      } catch (e) {
        this.error = this.errMsg(e) || 'No se pudo generar el Excel'
        this.dialogError = true
      } finally {
        this.exportandoReporte = false
      }
    },

    abrirSolicitarBaja(item) {
      if (!this.puedeEditarBajaPromesa) return
      if (!item || item.baja_solicitada) return
      this.alumnoBaja = item
      this.motivoBaja = ''
      this.confirmaBaja = false
      this.dialogBaja = true
    },

    abrirInfoBaja(item) {
      if (!item || !item.baja_solicitada) return
      this.alumnoBajaInfo = item
      this.dialogBajaInfo = true
    },

    cerrarInfoBaja() {
      this.dialogBajaInfo = false
      this.alumnoBajaInfo = null
    },

    cerrarSolicitarBaja() {
      if (this.guardandoBaja) return
      this.dialogBaja = false
      this.alumnoBaja = null
      this.motivoBaja = ''
      this.confirmaBaja = false
    },

    confirmarSolicitarBaja() {
      const motivo = String(this.motivoBaja || '').trim()
      if (!motivo) {
        this.error = 'El motivo es obligatorio para solicitar la baja'
        this.dialogError = true
        return
      }
      if (!this.confirmaBaja) {
        this.error = 'Debes confirmar que estás de acuerdo en solicitar la baja'
        this.dialogError = true
        return
      }
      if (!this.puedeEditarBajaPromesa || !this.alumnoBaja) return
      const item = this.alumnoBaja
      const idGrupo = this.chipContext && this.chipContext.item
        ? this.chipContext.item.id_grupo
        : null
      const idCiclo = this.idCicloRiAlumno(item)
      if (!idCiclo) {
        this.error = 'No se pudo determinar el ciclo para la baja'
        this.dialogError = true
        return
      }
      const u = this.getdatosUsuarioERPERP || {}
      const solicitanteNombre = u.nombre_completo || u.nombre || u.usuario || ''
      this.guardandoBaja = true
      this.$set(item, '_guardandoBaja', true)
      this.$http
        .patch('kpi.ri.alumno.baja.solicitada/' + item.id_alumno, {
          motivo,
          id_grupo: idGrupo,
          id_ciclo: idCiclo,
          solicitante_nombre: solicitanteNombre,
        })
        .then((res) => {
          const data = res.data || {}
          this.$set(item, 'baja_solicitada', true)
          this.$set(item, 'baja_motivo', data.baja_motivo || data.motivo || motivo)
          this.$set(
            item,
            'baja_solicitante',
            data.baja_solicitante || data.solicitante_nombre || solicitanteNombre
          )
          this.mensajeOk = 'Baja solicitada'
          this.snackbarOk = true
          this.dialogBaja = false
          this.alumnoBaja = null
          this.motivoBaja = ''
          this.confirmaBaja = false
          if (this.dialogReporte) this.cargarReporteSucursales()
        })
        .catch((e) => {
          this.error = this.errMsg(e)
          this.dialogError = true
        })
        .finally(() => {
          this.guardandoBaja = false
          this.$set(item, '_guardandoBaja', false)
        })
    },

    descargarCsvDetalle() {
      if (!this.chipContext || !this.cicloInf || !this.cicloSup) return
      const { item, tipo } = this.chipContext
      const path =
        'kpi.ri.grupo.alumnos/' +
        item.id_grupo +
        '/' +
        this.cicloInf.id_ciclo +
        '/' +
        this.cicloInf.id_ciclo_relacionado +
        '/' +
        this.cicloSup.id_ciclo +
        '/' +
        this.cicloSup.id_ciclo_relacionado +
        '?tipo=' +
        encodeURIComponent(tipo) +
        '&export=csv'
      this.$http
        .get(path, { responseType: 'blob' })
        .then((res) => {
          const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `ri-grupo-${item.id_grupo}-${tipo}.csv`
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch((e) => {
          this.error = this.errMsg(e)
          this.dialogError = true
        })
    },

    onToggleValidado(item, val) {
      this.patchGrupo(item, { validado: !!val, motivo: item.motivo || '', comentarios: item.comentarios })
    },

    patchGrupo(item, partial) {
      const body = {}
      if (partial.validado !== undefined) body.validado = partial.validado
      if (partial.motivo !== undefined) body.motivo = partial.motivo
      if (partial.comentarios !== undefined) body.comentarios = partial.comentarios
      this.$http
        .patch('kpi.ri.grupo.recepcion/' + item.id_grupo, body)
        .then(() => {
          this.mensajeOk = 'Guardado'
          this.snackbarOk = true
        })
        .catch((e) => {
          this.error = this.errMsg(e)
          this.dialogError = true
        })
    },

    s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
      return buf
    },

    exportar() {
      let data = XLSX.utils.json_to_sheet(this.rigrupos)
      const workbook = XLSX.utils.book_new()
      const filename = 'RI_grupos'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      const wbout = XLSX.write(workbook, {
        bookType: 'xls',
        bookSST: false,
        type: 'binary',
      })
      const file = new File([new Blob([this.s2ab(wbout)])], filename + '.xls')
      const formData = new FormData()
      formData.append('file', file)
      this.$http
        .post('pdfs', formData)
        .then(() => {
          window.location = axios.defaults.baseURL + 'pdfs/' + filename + '.xls'
        })
        .catch((error) => {
          alert(this.errMsg(error))
          console.log(error)
        })
    },
  },
}
</script>

<style scoped>
.ri-tel-validacion .v-btn {
  text-transform: none;
  letter-spacing: normal;
  font-size: 11px;
  min-width: 72px !important;
  height: 28px !important;
}

.ri-chip-pendiente {
  cursor: pointer;
  font-weight: 600;
}

/* Sin Twilio: no abrir chat, pero el ícono conserva verde/rojo (no gris). */
.ri-chip-pendiente {
  cursor: pointer;
}
.ri-wa-btn--blocked {
  cursor: not-allowed !important;
  opacity: 1 !important;
}
.ri-wa-btn--blocked ::v-deep .v-icon {
  opacity: 1 !important;
}
</style>
